export const subscriberStatus = {
  NEVER_SUBSCRIBED: 'NEVER_SUBSCRIBED',
  FIRST_TIME_SUBSCRIBER: 'FIRST_TIME_SUBSCRIBER',
  RENEWAL_SUBSCRIBER: 'RENEWAL_SUBSCRIBER',
  WIN_BACK_SUBSCRIBER: 'WIN_BACK_SUBSCRIBER',
  EX_SUBSCRIBER: 'EX_SUBSCRIBER',
};
